import { useEffect } from "react";

export function HelmetProvider({ children }) {
  return children;
}

export default function SEO({ title, description, image, type = "website", url }) {
  const siteName = "Welcome to the Gas Station";
  const pageTitle = title ? title + " | " + siteName : siteName;
  const desc = description || "Premium beats, exclusive merch, and car culture. Fuel your creativity with high-octane sounds and streetwear.";

  useEffect(() => {
    document.title = pageTitle;

    const setMeta = (attr, key, content) => {
      if (!content) return;
      let el = document.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    setMeta("name", "description", desc);
    setMeta("property", "og:title", pageTitle);
    setMeta("property", "og:description", desc);
    setMeta("property", "og:type", type);
    setMeta("property", "og:site_name", siteName);
    if (image) setMeta("property", "og:image", image);
    if (url) setMeta("property", "og:url", url);
    setMeta("name", "twitter:card", image ? "summary_large_image" : "summary");
    setMeta("name", "twitter:title", pageTitle);
    setMeta("name", "twitter:description", desc);
    if (image) setMeta("name", "twitter:image", image);
  }, [pageTitle, desc, image, type, url]);

  return null;
}
